export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.system.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  
  'menu.system': '基础管理',
  'menu.system.company': '公司管理',
  'menu.system.department': '部门管理',
  'menu.system.role': '角色管理',
  'menu.system.menu': '菜单管理',
  'menu.system.account': '用户管理',
  'menu.system.supplier': '供应商管理',
  'menu.product': '产品管理',
  'menu.system.store': '店铺管理',
  'menu.product.productPerformance': '产品表现',
  'menu.product.listingList': 'Listing列表',
  'menu.product.competitors': '竞品管理',
  'menu.product.competitors.detail': '竞品详情',
  'menu.salesData': '销售数据',
  'menu.rma': 'RMA数据',
  'menu.salesData.salesTraceability': '售后追溯',
  'menu.rma.ramTraceability': 'RMA追溯',
  'menu.salesData.salesDataList': '销售数据列表',
  'menu.rma.ramDataAbalysis': '销售数据分析',
  'menu.procurementData.finishedProductTraceability': '成品追溯',
  'menu.procurementData': '采购数据',
  'menu.procurementData.supplierReturns': '供应商退货',
  'menu.officialWebsiteManagement': '官网管理',
  'menu.officialWebsiteManagement.onlineConsultation': '在线咨询',
  'menu.qualityControl': '品管助手',
  'menu.qualityControl.productScore': '亚马逊产品评分',
  'menu.qualityControl.lingxingProductScore': '领星产品评分',
  'menu.qualityControl.crawlerConfiguration': '爬虫配置',
  'menu.email': '邮件管理',
  'menu.email.mailManagement': '邮箱列表',
  'menu.email.mailingList': '收信箱',
  'menu.email.mailRules': '邮件规则',
  'menu.message': '消息管理',
  'menu.statistics': '统计考核',
  'menu.statistics.list': '考核列表',
  'menu.statistics.approvalList': '考核审批',
  'menu.NewProductStatistics': '新品统计',
  'menu.NewProductStatistics.MonthlyNewProductStatistics': '月度新品统计',
  'menu.NewProductStatistics.YearProductStatistics': '年度新品统计',
  'menu.NewProductStatistics.StandardInquiry': '绩效完成情况',
  'menu.NewProductStatistics.StandardInquirySet': '业绩指标配置',
  'menu.NewProductStatistics.PersonnelManagement': '人员管理',
  'menu.task': '任务管理',
  'menu.task.management': '任务管理',
  'menu.task.executionList': '任务执行列表',
};
